const footer = {
  footer: {
    imageTitle: 'Visit the Enphase Energy website',
    privacy: 'Privacy',
    terms: 'Terms',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. All rights reserved.',
    language: 'Language',
    production_ct: {
      verify_ct: "Verify CT",
      checlist_nodata: "Insufficient meter data available to perform this check",
      production_meter_verification: "Production Meter Verification",
      serial_no: "Serial No",
      polarity_check: "Polarity Check",
      polarity_check_failed: "Polarity Check Failed",
      ct_missing_branch_check: "Checking if CT has missing branch circuits",
      polarity_check_passed: "Polarity Check Passed",
      ct_no_missing_branch_circuit: "CT has no missing branch circuits",
      incorrect_direction_or_phase_message: "Production CT direction or phase might be incorrect",
      hide_details: "Hide Details",
      check_try_again: "Check the following and try again",
      pv_on_for_5_min: "Make sure the PV circuit is switched ON and has been ON for at least 5 minutes",
      l1_wires_production_ct_message: "Check that only L1 wires pass through production CT and the production flow is in the direction of CT arrow from PV to breaker",
      blue_white_wires_position_message: "Make sure that the blue and white wires are connected to the correct positions in the Gateway terminal block",
      wires_include_pv_generation_not_load_storage: "Make sure that the wires running through the production CT only include PV generation (not any loads or storage)",
      l1_a_correct_phase_message: "Ensure that correct phase ie  L1(a), is going through production CT",
      l1_phase_consistency_check_message: "Check L1 phase consistency using a digital meter and ensure L1 of PV circuits and L1 at Gateway are in same phase",
      missing_branch_warning: "Production CT might have missing branch circuits",
      test_only_valid_for_sunshine_hours: "This test is only valid for sunshine hours",
      reading_lower_than_expected: "Production readings are lower than expected. Check the following, then tap and try again",
      wires_include_all_pv_generation: "Make sure wires running through production CT included all the PV generation circuits",
      branch_circuit_reverse_check: "Make sure none of the branch circuits are going through the CT in reverse",
      storage_load_circuits_through_production_ct: "Make sure there are no storage or load circuits going through the production CT",
      show_details: "Show Details",
      verify_ct_not_supported_for_device: "Verify CT not supported for this device",
      verify_ct_timeStamp: "Checked on",
      verify_ct_systemID: "System ID",
      prodct_reversepolarity_text: "Production CT direction or phase might be incorrect",
      prodct_reverse_polarity_btn: "Reverse Polarity",
      verify_ct_timeout: "Request Timed Out. Please try again"
    }
  }
};

export default footer;
